module.exports = __webpack_public_path__ + "static/img/home.7ec22c65.png";